module.exports = __webpack_public_path__ + "img/code-variable.5aa57771.svg";